import { render, staticRenderFns } from "./Tissue.vue?vue&type=template&id=5172cd3b&scoped=true"
import script from "./Tissue.vue?vue&type=script&lang=js"
export * from "./Tissue.vue?vue&type=script&lang=js"
import style0 from "./Tissue.vue?vue&type=style&index=0&id=5172cd3b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5172cd3b",
  null
  
)

export default component.exports